import React from "react";
import PropTypes from "prop-types";

import Progress from "common/ProgressCircle";
import { applicationShape } from "lib/propTypes";

export default class HomeAlertCardFinish extends React.PureComponent {
    static propTypes = {
        apps: PropTypes.arrayOf(PropTypes.shape(applicationShape)).isRequired,
        maxList: PropTypes.number,
        progress: PropTypes.number,
    };

    static defaultProps = {
        maxList: 3,
        progress: 75,
    };

    renderAppTitles(appsToList) {
        return appsToList.map((app) => (
            <li key={app.position.id}>
                {app.position.title} - {app.position.company_name}
            </li>
        ));
    }

    renderMoreApps(moreApps) {
        if (moreApps > 0) {
            return <li>+{moreApps} more</li>;
        }
        return null;
    }

    render() {
        const appsToList = this.props.apps.slice(0, this.props.maxList);
        const moreApps = this.props.apps.length - appsToList.length;
        const positionIds = this.props.apps.map((a) => a.position.id).join(",");

        if (appsToList.length === 0) {
            return null;
        }

        return (
            <div className="cand-home__finish-card">
                <div className="cand-home__finish-card-percent-holder">
                    <Progress percentProgress={this.props.progress} strokeWidth={3} width={73}>
                        {this.props.progress}%
                    </Progress>
                </div>
                <p>Finish applying to:</p>
                <ul>
                    {this.renderAppTitles(appsToList)}
                    {this.renderMoreApps(moreApps)}
                </ul>
                <a href={`/app/start/?sn=2&p=${positionIds}`}>Finish Application</a>
            </div>
        );
    }
}
